<template>
  <v-list-item-action class="ma-0" v-if="!isPhoneBool">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon v-bind="attrs"
                v-on="on"
                color="disabled"
                size="13">mdi-cursor-default-click</v-icon>
      </template>
      <span>{{$t('double_clickable')}}</span>
    </v-tooltip>
  </v-list-item-action>
</template>

<script>
export default {
  name: "DoubleClickHint",
  props: ["tip"],
  components: {},

  data() {
    return {};
  },

  created() {},

  mounted() {},

  methods: {},

  computed: {},

  watch: {},
};
</script>

<style lang="scss" scoped>
</style>